import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import StoreView from "@/views/StoreView.vue";
import DetailView from "@/views/DetailView.vue";
import SuccessView from "@/views/SuccessView.vue";
import OrderView from "@/views/OrderView.vue";

const routes = [
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    {
        path: '/store',
        name: 'store',
        component: StoreView
    },
    {
        path: '/detail/:id',
        name: 'detail',
        component: DetailView
    },
    {
        path: '/success/:order',
        name: 'success',
        component: SuccessView
    },
    {
        path: '/order',
        name: 'order',
        component: OrderView
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach((to, from, next) => {
    // document.title = ""
  next()
})

export default router
